unit Sphinx.OidcClient.AuthState;

{$I Sphinx.inc}

interface

type
  /// <summary>
  /// Holds the state generated at the start of an authorization flow.
  /// </summary>
  /// <remarks>
  /// An instance is created by <c>TOidcClient.StartAuthorize</c> and must be kept available
  /// until <c>TOidcClient.FinishAuthorize</c> is called. It carries the authorization URL
  /// to redirect the user to, the PKCE verifier/challenge pair, the nonce, and any
  /// application-defined state that should survive the redirect round-trip.
  /// The object is also persisted via the internal storage so that the callback handler
  /// can look it up by the <c>state</c> parameter returned by the provider.
  /// </remarks>
  TAuthState = class {$IFDEF Pas2JS}external name 'Object'{$ENDIF}
  private
    FAuthorizeUrl: string{$IFDEF Pas2JS} external name 'authorize_url'{$ENDIF};
    FState: string{$IFDEF Pas2JS} external name 'state'{$ENDIF};
    FScope: string{$IFDEF Pas2JS} external name 'scope'{$ENDIF};
    FClientId: string{$IFDEF Pas2JS} external name 'client_id'{$ENDIF};
    FAppState: string{$IFDEF Pas2JS} external name 'app_state'{$ENDIF};
    FRedirectUri: string{$IFDEF Pas2JS} external name 'redirect_uri'{$ENDIF};
    FCodeVerifier: string{$IFDEF Pas2JS} external name 'code_verifier'{$ENDIF};
    FCodeChallenge: string{$IFDEF Pas2JS} external name 'code_challenge'{$ENDIF};

    FCreatedOn: TDateTime{$IFDEF Pas2JS} external name 'created_on'{$ENDIF};
    FNonce: string {$IFDEF Pas2JS}external name 'nonce'{$ENDIF};
    FResponseMode: string {$IFDEF Pas2JS}external name 'response_mode'{$ENDIF};
  public
{$IFDEF Pas2JS}
    constructor new;
{$ENDIF}
    /// <summary>Gets or sets the full authorization URL to redirect the user to.</summary>
    property AuthorizeUrl: string read FAuthorizeUrl write FAuthorizeUrl;
    /// <summary>Gets or sets the opaque state value sent to the provider and echoed back in the callback.</summary>
    property State: string read FState write FState;
    /// <summary>Gets or sets the scope string included in the authorization request.</summary>
    property Scope: string read FScope write FScope;
    /// <summary>Gets or sets the client identifier used in the authorization request.</summary>
    property ClientId: string read FClientId write FClientId;
    /// <summary>Gets or sets the application-defined state string preserved through the redirect round-trip.</summary>
    property AppState: string read FAppState write FAppState;
    /// <summary>Gets or sets the redirect URI included in the authorization request.</summary>
    property RedirectUri: string read FRedirectUri write FRedirectUri;
    /// <summary>Gets or sets the PKCE code verifier generated for this flow.</summary>
    /// <remarks>
    /// The verifier is a high-entropy random string. It is sent to the token endpoint during
    /// code exchange so the server can confirm it matches the <c>CodeChallenge</c> submitted
    /// with the original authorization request.
    /// </remarks>
    property CodeVerifier: string read FCodeVerifier write FCodeVerifier;
    /// <summary>Gets or sets the PKCE code challenge derived from <c>CodeVerifier</c>.</summary>
    property CodeChallenge: string read FCodeChallenge write FCodeChallenge;
    /// <summary>Gets or sets the date and time when this state object was created.</summary>
    property CreatedOn: TDateTime read FCreatedOn write FCreatedOn;
    /// <summary>Gets or sets the nonce value included in the authorization request for replay protection.</summary>
    property Nonce: string read FNonce write FNonce;
    /// <summary>Gets or sets the response mode requested from the provider (e.g. <c>query</c> or <c>fragment</c>).</summary>
    property ResponseMode: string read FResponseMode write FResponseMode;
  end;

implementation

end.
